import {IconButton, MenuItem, Paper} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {changeBosToolsRole, removeUserType} from 'Users/ducks/userEntry';
import {Application} from 'Users/models/Application';
import {BosToolsRole, InvalidBosToolsUserType, ValidBosToolsUserType} from 'Users/models/User/BosToolsUserType';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './BosToolsUserTypeEntry.sass';
import {Scope} from 'Shared/constants/Scope';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';

type BosToolsUserTypeEntryProps = {
  bosToolsUserType: InvalidBosToolsUserType | ValidBosToolsUserType;
  isEdit: boolean;
};

const BosToolsUserTypeEntry = (props: BosToolsUserTypeEntryProps) => {
  const dispatch = useDispatch();
  const {bosToolsUserType} = props;
  const {bosToolsRole} = bosToolsUserType.value;

  const scopes = useSelector(selectUserScopes);
  const hasUpdateAccess = hasAccessToScopeByApplication(scopes, Scope.UpdateUser, Application.BOSTools);

  return (
    <Paper className="bos-tools-user-type-entry">
      <IconButton
        className="bos-tools-user-type-entry__remove-button"
        onClick={() => dispatch(removeUserType(bosToolsUserType))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <Close />
      </IconButton>
      <p className="bos-tools-user-type-entry__title">Add BOS Tools Permissions</p>
      <p className="bos-tools-user-type-entry__description">
        Select a role and complete the appropriate fields to add BOS tools permissions to this user.
      </p>
      <OutlinedSelect
        className="bos-tools-user-type-entry__role-select"
        label="BOS Tools Role"
        value={bosToolsRole || ''}
        onChange={e => dispatch(changeBosToolsRole(parseInt(e.target.value, 10) as BosToolsRole))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <MenuItem value={BosToolsRole.Admin}>Admin</MenuItem>
      </OutlinedSelect>
    </Paper>
  );
};

export default BosToolsUserTypeEntry;
